import Vue from "vue";
import axios from "axios";

const api = axios.create({
  baseURL: process.env.VUE_APP_APIURL
});

const user = JSON.parse(localStorage.getItem("vuex"))?.userModule?.user;

if (user?.token) {
  api.defaults.headers.common = {
    Authorization: `Bearer ${user ? user.token : ""}`
  };
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      if (!localStorage.getItem("showedExpiredSession")) {
        localStorage.setItem("showedExpiredSession", true);
        setTimeout(() => {
          Vue.swal({
            title: "Sesión Expirada",
            html: "Por favor vuelve a iniciar sesión.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            allowOutsideClick: false
          }).then(() => {
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = `${process.env.VUE_APP_LOGIN_URL}`;
          });
        }, 1000);
      }
    }else {
      // handle other errors
      if (error.message === 'Network Error') {
        // show a message indicating a network error
        Vue.swal({
          title: "Error de Conexión",
          html: "Lo sentimos, parece que hay un problema de conexión. Por favor, comprueba tu conexión a Internet y vuelve a intentarlo más tarde.",
          icon: "error",
          confirmButtonText: "Aceptar",
          allowOutsideClick: false,
        });
      } else {
        // show a generic error message
        Vue.swal({
          title: "Error",
          html: "Lo sentimos, ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.",
          icon: "error",
          confirmButtonText: "Aceptar",
          allowOutsideClick: false,
        });
      }
    }
    return Promise.reject(error);
  }
);

const api2 = axios.create({
  baseURL: process.env.VUE_APP_APIURL2
});

const googlePlacesApi = axios.create({
  baseURL: 'https://places.googleapis.com/v1/',
  headers: {
    'Content-Type': 'application/json',
    'X-Goog-Api-Key': process.env.VUE_APP_MAPS_API_KEY || ''
  }
})

if (user?.token) {
  api2.defaults.headers.common = {
    Authorization: `Bearer ${user ? user.token : ""}`
  };
}

api2.interceptors.request.use(
  async (config) => {
    if (config.url && !config.url.toUpperCase().includes("REFRESH")) {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          await checkTokenExpiration(); // Verifica si el token sigue vigente
          const newToken = localStorage.getItem("token");
          if (newToken) {
            config.headers['Authorization'] = `Bearer ${newToken}`;
          }
        } catch (e) {
          console.error("Error al verificar el token:", e);
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);


api2.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      if (!localStorage.getItem("showedExpiredSession")) {
        localStorage.setItem("showedExpiredSession", true);
        setTimeout(() => {
          Vue.swal({
            title: "Sesión Expirada",
            html: "Por favor vuelve a iniciar sesión.",
            icon: "warning",
            confirmButtonText: "Aceptar",
            allowOutsideClick: false
          }).then(() => {
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = `${process.env.VUE_APP_WEBURL}signIn`;
          });
        }, 1000);
      }
    }else {
      console.group('3', error)
      // handle other errors
      if (error.message === 'Network Error') {
        // show a message indicating a network error
        Vue.swal({
          title: "Error de Conexión",
          html: "Lo sentimos, parece que hay un problema de conexión. Por favor, comprueba tu conexión a Internet y vuelve a intentarlo más tarde.",
          icon: "error",
          confirmButtonText: "Aceptar",
          allowOutsideClick: false,
        });
      } else {
        // show a generic error message
        Vue.swal({
          title: "Error",
          html: "Lo sentimos, ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.",
          icon: "error",
          confirmButtonText: "Aceptar",
          allowOutsideClick: false,
        });
      }
    }
    return Promise.reject(error);
  }
);

function decodeJWT(token) {
  try {
    const payload = token.split('.')[1];
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = atob(base64);
    return JSON.parse(decoded);
  } catch (error) {
    console.error("Error al decodificar JWT:", error);
    return null;
  }
}

// 🔁 Manejo de cola para múltiples solicitudes durante refresh
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};

// Función para refrescar token y reintentar
const refreshTokenAndRetry = async (originalRequest) => {
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    }).then(token => {
      originalRequest.headers['Authorization'] = `Bearer ${token}`;
      return api2(originalRequest);
    });
  }

  isRefreshing = true;

  try {
    //const response = await api2.post("/auth/refresh");

    const response = await api2.post("/auth/refresh", null, { withCredentials: true});


    const newToken = response.data.data.token;

    // Guardar en localStorage
    const vuex = JSON.parse(localStorage.getItem("vuex"));
    if (vuex?.userModule?.user) {
      //vuex.userModule.user.token = newToken;
      vuex.userModule.user = response.data.data;
      localStorage.setItem("token", newToken);
      localStorage.setItem("vuex", JSON.stringify(vuex));
    }

    // Actualizar headers globales
    api2.defaults.headers.common.Authorization = `Bearer ${newToken}`;

    processQueue(null, newToken);

    // Reintentar original con nuevo token
    //originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
    //return api2(originalRequest);
  } catch (error) {
    processQueue(error, null);
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = `${process.env.VUE_APP_LOGIN_URL}`;
    return Promise.reject(error);
  } finally {
    isRefreshing = false;
  }
};

// Exportar la función checkTokenExpiration
export async function checkTokenExpiration() {
  const token = localStorage.getItem("token");

  if (!token) return;

  const decoded = decodeJWT(token);
  const now = Date.now() / 1000;

  if (decoded?.exp && decoded.exp - now < 60) {
    //console.info("🕐 Token casi expirado, auto-refresh...");
    await refreshTokenAndRetry({ headers: {} }); // dummy request
  }
}

// eslint-disable-next-line import/prefer-default-export
export { api, api2, googlePlacesApi };
